import React from 'react'
import '../styles/loaderMain.css'

export default function LoaderMain() {
    return (
        <div className="loader-page">
            <span className="loader"></span>
        </div>

    )
}
